export default __webpack_public_path__ + "static/emanuele-dbde362a8bafd4fc122fdb76011c4a02.jpg";